import {
  Component,
  OnInit,
  Input,
  Pipe,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { PopupService } from "../../../services/shared/popup.service";
import { ToastrService } from "ngx-toastr";
import { ApplicationService } from "app/services/application.service";
import { UtilityServiceService } from "app/services/utility-service.service";
import { environment } from "../../../../environments/environment";
import { PermitService } from "app/services/permit.service";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { VehicleService } from "app/services/vehicle.service";
// import * as jsPDF from 'jspdf';
// import 'jspdf-autotable';
import { CarrierService } from "app/services/carrier.service";
import { CountryService } from "app/services/country.service";
import { CurrencyFormat } from "app/pipes/currencyFormat.pipe";
import { AuthWebService } from "app/services/authweb.service";
import { accounting } from "accounting";
import { DatePipe } from "@angular/common";
import { PermitTypeService } from "app/services/permit-type.service";
import { CompliancereturnsService } from "app/services/compliancereturns.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";

var jsPDF = require("jspdf");
require("jspdf-autotable");
declare var $;

// @Pipe({name: 'safeHtml'})

@Component({
  selector: "confirmation-viewer",
  templateUrl: "./confirmation-viewer.component.html",
  styleUrls: ["./confirmation-viewer.component.css"],
})
export class ConfirmationViewerComponent implements OnInit {
  public isLoading = false;
  helphtml;
  linkhtml;
  @Input() dataCntrl: any;
  @Input() routeDetials: any;
  userDetails: any = null;
  totalFee: number = 0;
  termsFlag: boolean = false;
  public pageload: boolean = false;
  public pageload2: boolean = false;
  enabledBtnsFlag: boolean = false;
  @ViewChild("content", { static: true }) content: ElementRef;
  status_id: number;
  email_body = "";
  decl_date = new Date();
  vehicles: any = [];
  pageload3: boolean = true;
  countries: any = {};
  lineTotal;
  permitStatus1: any;
  permitStatus2: any;
  message: string = "Loading. Please wait...";
  money: string = "color: red";

  ptype: any = null;
  ptypeDays: any = null;
  ptypeMonth: any = null;
  ptypeYears: any = null;
  complianceCertficateList: any = [];
  showFooter: boolean = false;
  constructor(
    private sanitizer: DomSanitizer,
    private showModal: PopupService,
    private toastr: ToastrService,
    private toastService: ToastNotificationService,
    private applicationService: ApplicationService,
    public utility: UtilityServiceService,
    private permitService: PermitService,
    private router: Router,
    private vehicleService: VehicleService,
    private datePipe: DatePipe,
    private carrierService: CarrierService,
    private countryService: CountryService,
    public currformat: CurrencyFormat,
    private authWebService: AuthWebService,
    private permittypeService: PermitTypeService,
    private complianceService: CompliancereturnsService
  ) {}

  ngOnInit() {
    if (this.routeDetials == "application") {
      this.showFooter = true;
    } else {
      this.showFooter = true;
    }
    console.log(this.routeDetials, "Confirmation COmponent");
    this.setHTMLDATA();
    this.userDetails = environment.authWebApi.userData.User;
    if (
      environment.authWebApi.systemData != null &&
      environment.authWebApi.systemData.Configurations != null
    ) {
      this.permitStatus1 =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "PermitStatus2"
        ).Value;
      this.permitStatus2 =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "PermitStatus4"
        ).Value;
    }
    //console.log(this.permitStatus1);
    // this.totalFee = (this.dataCntrl['permit'].application_fee + this.dataCntrl['permit'].permit_fee)*this.dataCntrl['vehicles'].length;

    //console.log(this.dataCntrl);
    setTimeout(() => {
      this.getApplication();
    }, 2000);

    this.getSavedVehicleByPermit(this.dataCntrl.application.id, "update");
    this.getCountries();
    console.log(this.dataCntrl.vehicles);
  }

  getComplianceCertificates() {
    //alert(this.dataCntrl.permits.length);
    this.complianceCertficateList = [];
    this.dataCntrl.permits.forEach((permit: any) => {
      this.complianceService
        .GetComplianceCertificatesById(permit.id)
        .subscribe((c: any) => {
          if (c.length > 0) {
            c.forEach((cert) => {
              this.complianceCertficateList.push(cert);
            });
          }
        });
    });
  }
  checkTerms(event) {
    if (event.target.checked) {
      this.termsFlag = true;
    } else {
      this.termsFlag = false;
    }
  }
  getApplication() {
    this.pageload = true;
    this.utility.permitAppId = this.dataCntrl.application.id;
    if (
      this.dataCntrl.application.id !== null &&
      this.dataCntrl.application.id !== undefined
    ) {
      this.applicationService.getById(this.dataCntrl.application.id).subscribe(
        (data: any) => {
          this.pageload = true;
          //console.log(data.vehicle);

          this.dataCntrl.application = data;
          //console.log(this.dataCntrl.application);
          this.dataCntrl.carrierID = data.carrier_id;
          this.utility.carrierId = data.carrier_id;
          this.dataCntrl.permit_type_id = data.permit_type_id;
          // alert(JSON.stringify(data.permits));
          this.dataCntrl.permits = data.permits;
          this.dataCntrl.permittype = data.permit_type;
          this.utility.permitStatusId = data.status_id;
          this.utility.permitFreightId = data.permit_type.freight_passenger_ind;
          //setTimeout(()=>{
          //this.dataCntrl.vehicles=data.vehicle;

          // this.dataCntrl['permit'].forEach(perm=> {
          //   this.lineTotal = (perm.application_fee + perm.permit_fee);
          //   this.totalFee += this.lineTotal;
          // });
          // this.totalFee = (this.dataCntrl['permit'].application_fee + this.dataCntrl['permit'].permit_fee)*this.dataCntrl.vehicles.length;
          //  //console.log(this.formatCurrency(this.totalFee))
          //this.lineTotal = (this.dataCntrl['permit'].application_fee + this.dataCntrl['permit'].permit_fee);
          // this.lineTotal = this.formatCurrency(this.lineTotal);
          //   this.totalFee = this.formatCurrency(this.totalFee);
          this.pageload = false;
          this.getCarrier();
          this.getCorrectionPermitType();
          //},3000);

          if (this.dataCntrl.permittype.annual_compliance_reqd) {
            // alert('yes')
            this.getComplianceCertificates();
          }
        },
        (error) => {
          this.pageload = false;
          //console.log(error);
        }
      );
    } else {
      //this.vehicles=this.dataCntrl.vehicles;
      //setTimeout(()=>{
      // this.totalFee = (this.dataCntrl['permit'].application_fee + this.dataCntrl['permit'].permit_fee)*this.dataCntrl.vehicles.length;
      // //  //console.log(this.formatCurrency(this.totalFee))
      // this.lineTotal = (this.dataCntrl['permit'].application_fee + this.dataCntrl['permit'].permit_fee);
      // this.lineTotal = this.formatCurrency(this.lineTotal);
      //   this.totalFee = this.formatCurrency(this.totalFee);
      this.getCarrier();
      this.getCorrectionPermitType();
      //},3000);
    }
    this.pageload = false;
  }
  formatCurrency(value) {
    return accounting.formatMoney(value, "R", 2, " ", ".");
  }
  getCarrier() {
    this.pageload = true;
    this.carrierService.getById(this.dataCntrl.carrierID).subscribe(
      (result) => {
        this.setCarrierData(result);
        this.pageload = false;
      },
      (error) => {
        this.pageload = false;
        //console.log(error);
      }
    );
    this.pageload = false;
  }
  getCorrectionPermitType() {
    this.pageload = true;
    this.permittypeService
      .getById(this.dataCntrl["permit"].permit_type_id)
      .subscribe(
        (type: any) => {
          this.ptype = type;
          //console.log(this.ptype);
          if (type.permit_days > 0) {
            this.ptypeDays = type.permit_days;
          }
          if (type.permit_months > 0) {
            this.ptypeMonth = type.permit_months;
          }
          if (type.permit_years > 0) {
            this.ptypeYears = type.permit_years;
          }
          this.pageload2 = false;
        },
        (error) => {
          this.pageload2 = false;
        }
      );
  }

  setCarrierData(data) {
    // Country
    let thisCountry = this.countries.find((x) => x.id == data.country_id);
    data.country_dial_code = thisCountry.dial_code;
    data.country_description = thisCountry.desc;
    data.country_code = thisCountry.code;

    // Account Balance
    data.account_balance = data.account_balance * -1;
    let colr = data.account_balance > 0 ? "green" : "red";
    document.getElementById("Money").style.color = colr;
    data.account_balance =
      data.account_balance == 0
        ? "R 0.00"
        : this.currformat.transform(parseFloat(data.account_balance));

    this.dataCntrl.carrier = data;
    //console.log(this.dataCntrl.carrier);
  }

  getCountries() {
    this.pageload = true;
    this.countryService.listAllCountries().subscribe((result) => {
      this.countries = result;
      this.pageload = false;
    });
  }

  saveConfirmation() {
    this.pageload = true;
    if (!this.termsFlag) {
      this.pageload = false;
      return this.toastService.error("Please agree the terms", "Terms");
    }
    this.permitService.sendEmail(this.userDetails.EmailAddress).subscribe(
      (result) => {
        //console.log(result);
        this.pageload = false;
        this.isLoading = false;
        if (result == true) {
          this.retrieveSubmitStatus();

          //this.dialogService.addDialog(AlertComponent, { title: `Carrier Account Submission`, message: `Carrier Account with registration number  ${this.caConfirmObj.registration_number} submitted successfully.`, bold: `${this.caConfirmObj.registration_number}` });
          //this.utility.activeTab = 1;
        } else {
          this.pageload = false;
          this.toastService.error(
            `Submission for   failed.Please contact the system administrator if the problem persists.`,
            "Failed Submission"
          );
        }
      },
      (error) => {
        this.pageload = false;
        this.isLoading = false;
        this.toastService.error(
          `Submission for failed.Please contact the system administrator if the problem persists.`,
          "Failed Submission"
        );
        //this.dialogService.addDialog(AlertComponent, { title: `Carrier Account Submission`, message: `Submission for  ${this.caConfirmObj.registration_number} failed.Please contact the system administrator if the problem persists.`, bold: `${obj.registered_name}` });
      }
    );
  }
  setHTMLDATA() {
    if (environment.authWebApi.systemData != null) {
      let link = environment.authWebApi.systemData.Configurations.find(
        (p) => p.Code == "HTMLDec2"
      );
      this.linkhtml = this.sanitizer.bypassSecurityTrustHtml(link.Value);
    }
  }
  retrieveSubmitStatus() {
    if (this.authWebService.userData) {
      this.pageload = true;
      this.status_id = +environment.authWebApi.systemData.Configurations.find(
        (config) => config.Code == "AccountStatus2"
      ).Value;
      this.dataCntrl.application.status_id = this.status_id;
      this.dataCntrl.application.submission_date = new Date();

      this.applicationService
        .putApplication(this.dataCntrl.application)
        .subscribe(
          (result) => {
            //console.log(result);
            this.toastService.success(
              `Your permit application was submitted successfully.`,
              "Permit Application"
            );
            this.router.navigate([
              "/carrier/permit/application/" + this.dataCntrl.carrierID,
            ]);
            this.pageload = false;
          },
          (error) => {
            //console.log(error);
            this.pageload = false;

            // this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.','Save Application')

            // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
            return;
          }
        );
    }
  }
  downloadPdf() {
    var img = new Image();
    img.src = "/assets/banner1.png";
    let doc = new jsPDF();
    doc.addImage(img, "png", 0, 0, 220, 50);
    doc.fromHTML($("#confirm-content-1").html(), 10, 50, {
      width: 500,
    });
    doc.autoTable({
      html: "#pdfTable",
      margin: { top: 90 },
      columnStyles: {
        "Reg #": { columnWidth: 100 },
      },
    });
    doc.save("permitApplication.pdf");
  }

  // cancelApplication(){
  //   if(this.dataCntrl.application.id==undefined && this.dataCntrl.application.id==null){
  //     this.router.navigate(['/carrier/permit/application/'+this.dataCntrl.carrierID]);
  //   }else{
  //     this.showModal.showConfirm('Delete Application', 'Are you sure you want to delete?', `You're about to delete application`, 'Yes', 'No')
  //     .subscribe((isConfirmed) => {
  //       if (isConfirmed) {
  //         this.deleteApplication()
  //       } else {
  //         return;
  //       }
  //     });
  //   }
  // }
  //   deleteApplication(){
  //     //console.log("delete application");
  //     this.pageload = true;

  //     this.permitService.deletePermit(this.dataCntrl.permit.id).subscribe(x =>{
  //       //console.log(x);
  //     this.deleteApp(this.dataCntrl.application.id);
  //     this.pageload = false;

  //     this.router.navigate(['/carrier/permit/application/'+this.dataCntrl.carrierID]);

  //     })
  // //this.dataCntrl.application.id
  // //this.dataCntrl.permit.id
  //   }
  // deletePermit(id){
  //   this.pageload = true;
  //   this.permitService.deletePermit(id).subscribe(x =>{
  //     this.pageload = false;
  //     //console.log(x);
  //   })

  // }
  // deleteApp(id){
  //   this.pageload = true;
  //   this.applicationService.deleteApplication(id).subscribe(x =>{
  //     this.pageload = false;
  //     //console.log(x);
  //   })
  // }
  getSavedVehicleByPermit(appId, loadType) {
    this.pageload2 = true;
    this.vehicles = [];

    this.permitService
      .getAllPermitsByApplicationId(appId)
      .subscribe((data: any) => {
        // this.pageload2 = true;

        //console.log(data.filter(i => i.application_id ==appId))
        let permits = data.filter((i) => i.application_id == appId);
        this.vehicleService.getPermitsAppVecle(appId).subscribe((x: any) => {
          this.vehicles = [];
          if (permits.length > 0) {
            for (let p = 0; p < permits.length; p++) {
              //console.log(permits[p].id)

              //console.log(x.filter(i => i.permit_id == permits[p].id))
              let allVeh = x.filter((i) => i.permit_id == permits[p].id);
              //console.log(allVeh.length)
              for (let v = 0; v < allVeh.length; v++) {
                let myPerm = this.dataCntrl["permit"].find(
                  (element) => element.id == allVeh[v].permit_id
                );
                this.vehicleService
                  .getAllVe(allVeh[v].permit_id)
                  .subscribe((vehicles: any) => {
                    //console.log(vehicles)
                    let object = {
                      id: vehicles.id,
                      vehicle_type_id: vehicles.vehicle_type_id,
                      vehicle_make_id: vehicles.vehicle_make_id,
                      vehicle_make: vehicles.vehicle_make,
                      vehicle_type: vehicles.vehicle_type,
                      is_current: false,
                      registration_number: vehicles.registration_number,
                      seating_capacity: vehicles.seating_capacity,
                      gvn: vehicles.gvn,
                      vin: vehicles.vin,
                      date_license_expiry: this.datePipe.transform(
                        vehicles.date_license_expiry,
                        "dd/MM/yyyy"
                      ),
                      start_date: this.datePipe.transform(
                        vehicles.start_date,
                        "dd/MM/yyyy"
                      ),
                      editMode: false,
                      application_fee: myPerm.application_fee,
                      permit_fee: myPerm.permit_fee,
                      lineTotal: myPerm.application_fee + myPerm.permit_fee,
                    };
                    this.totalFee += object.lineTotal;

                    //console.log(object)
                    //   if(this.vehicles.length === data.vehicle.length){
                    // //console.log('Its 0')
                    //  this.vehicles = this.dataCntrl.vehicles ;
                    //  this.pageload = false;

                    // return;
                    //   }
                    this.vehicles.push(object);
                    this.pageload = false;
                    //console.log(this.vehicles)

                    this.dataCntrl.vehicles = this.vehicles;
                  });
              }
              this.pageload = false;
            }
          } else {
            this.pageload = false;
          }

          // this.newvehicles.push(x)
          //  //console.log(this.newvehicles)
          //  this.dataCntrl.vehicles = this.newvehicles
          // //  this.vehicles = this.dataCntrl.vehicles;
        });

        this.pageload = true;
      });
    //this.pageload = true;
    //
  }
}
